(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beam-about-article"]) return;
  try {
    
  document.querySelectorAll('.beam-airtime-content table').forEach((table, index) => {
    if (table.parentElement.classList.contains('beam-airtime-table-scroll')) return;
    const scroller = document.createElement('div');
    scroller.className = 'beam-airtime-table-scroll';
    scroller.tabIndex = 0;
    scroller.setAttribute('role', 'region');
    scroller.setAttribute('aria-label', `Airtime plan table ${index + 1}`);
    table.before(scroller);
    scroller.appendChild(table);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-footer"]) return;
  try {
    
  document.querySelectorAll('.beam-back-to-top').forEach((button) => {
    const scroller = document.querySelector('.page-wrapper') || document.scrollingElement;
    const scrollEvents = scroller === document.scrollingElement ? window : scroller;
    let hideTimer;
    const hide = () => { if (document.activeElement !== button) button.hidden = true; };
    scrollEvents.addEventListener('scroll', () => {
      if (scroller.scrollTop <= 500) { clearTimeout(hideTimer); hide(); return; }
      if (button.hidden) {
        button.hidden = false;
        clearTimeout(hideTimer);
        hideTimer = setTimeout(hide, 5000);
      }
    }, { passive: true });
    button.addEventListener('blur', hide);
    button.addEventListener('click', () => {
      document.querySelector('.beam-header__logo')?.focus({ preventScroll: true });
      scroller.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      button.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-header"]) return;
  try {
    
  document.querySelectorAll('.beam-header').forEach((header) => {
    const menus = header.querySelectorAll('.beam-mega');
    let closeTimer;
    let keyboardNavigation = false;
    // Clicking a summary leaves it focused. That must not pin a hover menu open
    // after the pointer leaves; retain focus only for keyboard navigation.
    header.addEventListener('keydown', () => { keyboardNavigation = true; });
    header.addEventListener('pointerdown', () => { keyboardNavigation = false; });
    const search = header.querySelector('.beam-header__search');
    const mobile = header.querySelector('.beam-header__mobile');
    // Reuse the desktop link inventory so mobile cannot silently lose categories.
    mobile.querySelectorAll('.beam-mobile-group__columns > div').forEach((column) => {
      let group;
      Array.from(column.children).forEach((link) => {
        if (link.classList.contains('beam-mobile-group__heading')) {
          group = null;
          if (link.nextElementSibling && !link.nextElementSibling.classList.contains('beam-mobile-group__heading')) {
            group = document.createElement('details');
            group.className = 'beam-mobile-subgroup';
            const summary = document.createElement('summary');
            const label = link.childNodes[0].textContent.trim();
            column.insertBefore(group, link);
            group.append(summary);
            link.textContent = label;
            link.classList.remove('beam-mobile-group__heading');
            summary.append(link);
          }
        } else if (group) {
          group.append(link);
        }
      });
    });
    // Desktop columns interleave the bottom links; the original phone menu lists
    // the three category groups first, followed by airtime and the catalogue.
    const satelliteColumns = mobile.querySelector('.beam-mobile-group--satellite .beam-mobile-group__columns');
    if (satelliteColumns) {
      const groups = Array.from(satelliteColumns.querySelectorAll('.beam-mobile-subgroup'));
      const trailingLinks = Array.from(satelliteColumns.querySelectorAll('.beam-mobile-group__heading'));
      const column = document.createElement('div');
      column.append(...groups, ...trailingLinks);
      satelliteColumns.replaceChildren(column);
    }
    const mobileGroups = mobile.querySelectorAll('nav > .beam-mobile-group');
    mobile.querySelectorAll('.beam-mobile-group > summary, .beam-mobile-subgroup > summary').forEach((summary) => {
      summary.setAttribute('aria-label', summary.textContent.trim());
    });
    mobileGroups.forEach((group) => group.addEventListener('toggle', () => {
      if (group.open) mobileGroups.forEach((other) => { if (other !== group) other.open = false; });
    }));
    const closeMenus = () => { clearTimeout(closeTimer); menus.forEach((menu) => { menu.open = false; }); };
    const closeAll = () => { closeMenus(); search.open = false; mobile.open = false; };
    const openMenu = (menu) => { clearTimeout(closeTimer); search.open = false; menus.forEach((other) => { other.open = other === menu; }); };
    menus.forEach((menu) => {
      const summary = menu.querySelector('summary');
      let openedByHover = false;
      summary.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && window.matchMedia('(min-width: 1280px)').matches) {
          openedByHover = !menu.open;
          openMenu(menu);
        }
      });
      summary.addEventListener('click', (event) => {
        // Linked labels navigate while hover and arrow keys still open the panel.
        if (event.target.closest?.('a')) return;
        // The first click after hover keeps the panel open; a second click closes it.
        if (event.pointerType === 'mouse' && openedByHover && menu.open) event.preventDefault();
        openedByHover = false;
      });
      summary.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          const index = Array.from(menus).indexOf(menu);
          const next = menus[(index + (event.key === 'ArrowRight' ? 1 : -1) + menus.length) % menus.length];
          if (menu.open) openMenu(next);
          next.querySelector('summary').focus();
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          openMenu(menu);
          const links = menu.querySelectorAll('.beam-mega__panel a');
          (event.key === 'ArrowUp' ? links[links.length - 1] : links[0])?.focus();
        }
      });
      menu.addEventListener('pointerenter', () => clearTimeout(closeTimer));
      menu.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') closeTimer = setTimeout(() => {
          if (!keyboardNavigation || !menu.contains(document.activeElement)) menu.open = false;
        }, 220);
      });
      menu.addEventListener('focusout', () => { setTimeout(() => { if (!menu.contains(document.activeElement) && !menu.matches(':hover')) menu.open = false; }, 0); });
    });
    document.addEventListener('pointerdown', (event) => { if (!header.contains(event.target) || event.target.classList.contains('beam-menu-backdrop')) closeAll(); });
    search.addEventListener('toggle', () => { if (search.open) closeMenus(); });
    window.matchMedia('(min-width: 1280px)').addEventListener('change', closeAll);
    menus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        if (menu.open) { search.open = false; menus.forEach((other) => { if (other !== menu) other.open = false; }); }
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const nested = event.target.closest?.('.beam-mobile-subgroup[open], .beam-mobile-group[open], .beam-mobile-search-toggle[open]');
        if (mobile.open && nested && mobile.contains(nested)) {
          event.preventDefault();
          nested.open = false;
          nested.querySelector('summary').focus();
          return;
        }
        const opened = Array.from(menus).find((menu) => menu.open) || (search.open ? search : mobile.open ? mobile : null);
        if (!opened) return;
        // Escape must also dismiss a hover-opened menu when focus is on the page.
        event.preventDefault();
        closeAll();
        opened.querySelector('summary').focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-homepage"]) return;
  try {
    
  document.querySelectorAll('.beam-applications').forEach((section) => {
    const panels = section.querySelectorAll('.beam-application');
    const tabs = section.querySelectorAll('.beam-tabs a');
    const mobileLayout = window.matchMedia('(max-width: 767.98px)');
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'beam-application-toggle';
    const tabList = section.querySelector('.beam-tabs');
    tabList.id = 'beam-application-options';
    toggle.setAttribute('aria-controls', tabList.id);
    toggle.setAttribute('aria-expanded', 'false');
    section.appendChild(toggle);
    const backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'beam-application-backdrop';
    backdrop.setAttribute('aria-label', 'Close applications menu');
    backdrop.tabIndex = -1;
    backdrop.hidden = true;
    section.appendChild(backdrop);
    const setSelecting = (open) => {
      section.classList.toggle('is-selecting', open);
      toggle.setAttribute('aria-expanded', String(open));
      backdrop.hidden = !open;
      tabs.forEach(tab => { tab.tabIndex = mobileLayout.matches && open || tab.classList.contains('is-active') ? 0 : -1; });
    };
    toggle.addEventListener('click', () => setSelecting(toggle.getAttribute('aria-expanded') !== 'true'));
    backdrop.addEventListener('click', () => { setSelecting(false); toggle.focus(); });
    toggle.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown') { event.preventDefault(); setSelecting(true); tabList.querySelector('.is-active').focus(); }
    });
    section.addEventListener('keydown', event => {
      if (event.key === 'Escape' && section.classList.contains('is-selecting')) { event.preventDefault(); setSelecting(false); toggle.focus(); }
    });
    document.addEventListener('pointerdown', event => { if (!section.contains(event.target)) setSelecting(false); });
    document.addEventListener('focusin', event => { if (!section.contains(event.target)) setSelecting(false); });
    mobileLayout.addEventListener('change', () => setSelecting(false));
    section.querySelector('.beam-tabs').setAttribute('role', 'tablist');
    const labels = { building: 'All building products', emergency: 'All emergency products', transport: 'All transport products' };
    panels.forEach((panel) => {
      panel.setAttribute('role', 'tabpanel');
      if (!panel.querySelector('.beam-button') && labels[panel.id]) {
        const link = document.createElement('a');
        link.className = 'beam-button';
        link.href = section.querySelector('#maritime .beam-button').getAttribute('href').replace(/maritime$/, panel.id === 'building' ? 'in-building' : panel.id);
        link.textContent = labels[panel.id];
        panel.querySelector('div').appendChild(link);
      }
    });
    tabs.forEach((tab, index) => {
      tab.id = `beam-application-tab-${index}`;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[index].id);
      panels[index].setAttribute('aria-labelledby', tab.id);
    });
    const activate = (id) => {
      panels.forEach((panel) => panel.classList.toggle('is-active', `#${panel.id}` === id));
      tabs.forEach((tab) => {
        const selected = tab.getAttribute('href') === id;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected) toggle.textContent = tab.textContent.trim();
      });
    };
    activate('#maritime');
    tabs.forEach((tab) => tab.addEventListener('click', (event) => { event.preventDefault(); activate(tab.getAttribute('href')); setSelecting(false); if (mobileLayout.matches) toggle.focus(); }));
    tabs.forEach((tab, index) => tab.addEventListener('keydown', (event) => {
      const next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : null;
      if (next === null) return;
      event.preventDefault();
      activate(tabs[next].getAttribute('href'));
      tabs[next].focus();
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-resellers"]) return;
  try {
    
document.querySelectorAll('.beam-reseller-directory').forEach(directory=>{
  const message=directory.querySelector('.beam-region-message');
  const regions=Array.from(directory.querySelectorAll('.beam-region-results')).map(el=>el.dataset.region);
  let region=new URLSearchParams(location.search).get('region');
  const update=()=>{
    const valid=regions.includes(region);message.hidden=valid;
    directory.querySelectorAll('.beam-region-results').forEach(el=>el.hidden=el.dataset.region!==region);
    directory.querySelectorAll('.beam-regions a').forEach(a=>{if(a.dataset.region===region)a.setAttribute('aria-current','page');else a.removeAttribute('aria-current');});
    directory.querySelectorAll('.beam-region-map a').forEach(a=>a.classList.toggle('active',!!region&&a.classList.contains(region)));
  };
  directory.querySelectorAll('a[href^="?region="]').forEach(a=>a.addEventListener('click',event=>{event.preventDefault();region=new URL(a.href).searchParams.get('region');history.pushState(null,'',a.href);update();}));
  window.addEventListener('popstate',()=>{region=new URLSearchParams(location.search).get('region');update();});update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-support-centre"]) return;
  try {
    
  (() => {
    const input = document.getElementById('beam-support-product-search');
    const list = document.getElementById('beam-support-product-results');
    const status = document.getElementById('beam-support-product-status');
    if (!input || !list || !status) return;
    const items = Array.from(list.children);
    const render = () => {
      const term = input.value.trim().toLocaleLowerCase();
      let count = 0;
      items.forEach((item) => {
        const match = item.textContent.toLocaleLowerCase().includes(term);
        item.hidden = !match;
        if (match) count++;
      });
      status.textContent = count ? `${count} products` : 'No matching products. Try another product name.';
    };
    input.addEventListener('input', render);
    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
